"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewAndBookHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _intl = require("@kyruus/intl");
var _react2 = require("@xstate/react");
var _States = require("../../lib/constants/States");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _styles = require("./styles");
var _utils = require("../../lib/utils");
var _configUtils = require("../../lib/configUtils");
var _BookButton = _interopRequireDefault(require("../BookButton"));
var _Banners = require("../Banners");
var _useWindowWidth = _interopRequireDefault(require("../../lib/useWindowWidth"));
var _propTypes2 = require("../../lib/propTypes");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ReviewAndBookHeader = _ref => {
  let {
    bodyIsAnimating,
    config,
    onScroll,
    service,
    track
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    provider,
    selectedAppointment
  } = state.context;
  /**
   * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
   */
  const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider, selectedAppointment);
  let message = _messages.default.reviewAndBook;
  if (state.matches(_States.apptUnavailable)) {
    message = _messages.default.apptUnavailable;
  }

  // scroll to top on smaller screens so ErrorBookingBanner is visible
  const {
    aboveMd
  } = (0, _useWindowWidth.default)();
  const errorState = state.matches(_States.error);
  (0, _react.useEffect)(() => {
    if (!aboveMd && errorState && onScroll) {
      onScroll();
    }
  }, [aboveMd, errorState, onScroll]);

  /**
   * hide the booking button in mobile view until animation is finished
   * to prevent the button from jumping to the bottom of the screen
   */
  const hideBookingButton = bodyIsAnimating && !aboveMd;
  return /*#__PURE__*/_react.default.createElement(_styles.HeaderContainer, {
    "data-testid": "ReviewAppt__Header"
  }, /*#__PURE__*/_react.default.createElement(_styles.PageHeading, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, message, {
    values: {
      display_name: (0, _utils.formatProviderName)(provider)
    }
  }))), /*#__PURE__*/_react.default.createElement(_styles.Instructions, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.reviewAndBookInstructions)), !state.matches(_States.apptUnavailable) && !hideBookingButton &&
  /*#__PURE__*/
  /* static class name used in PMC to target this container
  when DBW is rendered in a drawer */
  _react.default.createElement(_styles.ButtonContainer, {
    className: "BookButtonContainer"
  }, /*#__PURE__*/_react.default.createElement(_BookButton.default, {
    "data-testid": "ReviewAppt__BookBtn",
    service: service,
    track: track
  })), state.matches(_States.error) && /*#__PURE__*/_react.default.createElement(_styles.ErrorsContainer, {
    "data-testid": "ReviewAppt-errorMsg"
  }, /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
    phone: phone
  })));
};
exports.ReviewAndBookHeader = ReviewAndBookHeader;
ReviewAndBookHeader.propTypes = {
  bodyIsAnimating: _propTypes.bool,
  config: _propTypes2.configType,
  onScroll: _propTypes.func,
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired
};
ReviewAndBookHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ReviewAndBookHeader",
  "props": {
    "bodyIsAnimating": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "custom",
        "raw": "configType"
      },
      "required": false
    },
    "onScroll": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};